"use client";
import React, { useRef } from "react";
import style from "./Hero.module.scss";
import gsap from "gsap";
import { useDeviceDetector } from "@/utils/useDeviceDetector";
import { useGSAP } from "@gsap/react";
import { SharedCanvas } from "@/components/common/SharedCanvas";
import { View } from "@/utils/CustomView";
import { Ducks } from "@/components/Home/Duo/Ducks";
import CustomSpotLight from "@/components/common/3D/CustomSpotLight";
import { PerspectiveCamera } from "@react-three/drei";
import { SearchBar } from "../../SearchBar/SearchBar";

export const Hero = ({ hero }) => {
  const heroRef = useRef(null);
  const wrapRef = useRef(null);
  const canvasRef = useRef();
  const { isMobile } = useDeviceDetector();

  useGSAP(
    () => {
      gsap.fromTo(
        ".firstText",
        {
          x: "-50%",
          opacity: 0,
        },
        {
          x: "0%",
          opacity: 1,
          duration: 1,
          ease: "power4.out",
        }
      );
      gsap.fromTo(
        ".secondText",
        {
          x: "50%",
          opacity: 0,
        },
        {
          x: "0%",
          opacity: 1,
          duration: 1,
          ease: "power4.out",
        }
      );
    },
    { scope: heroRef }
  );
  return (
    <section ref={wrapRef} className={style.heroWrap}>
      <SharedCanvas ref={canvasRef}></SharedCanvas>
      {/*@ts-ignore*/}
      <View className={style.blogCanvas}>
        <PerspectiveCamera makeDefault fov={60} position={[0, 0, 8]} />
        <ambientLight intensity={1.5} />
        <CustomSpotLight intensity={50} position={[8, 7, 0]} />
        <CustomSpotLight intensity={25} position={[0, 7, 3]} />
        <Ducks scale={3} position={[2.5, 0.5, 0]} rotation={[15, 0, 0]} />{" "}
      </View>
      <div className="container-blog">
        <div className={style.title} ref={heroRef}>
          <h1 className="title-section">
            <span className="firstText">{hero.first_words}</span>
            <pre className="secondText">
              <span>{hero.second_words}</span>
              <span className={`title-outline`}>{hero.last_words}</span>
            </pre>
          </h1>
          {hero.description && <p className="paragraph">{hero.description}</p>}
        </div>

        {isMobile && (
          <SearchBar blogParams={true} isOpen={true} fullWidth={true} />
        )}
      </div>
    </section>
  );
};
